var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#10ad7d;}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-260 -228)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(260 228)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 8,
    transform: "translate(272 244)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 8,
    transform: "translate(276 240)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusbtn);
export default __webpack_public_path__ + "static/media/plusbtn.f3d10cb86606b0862a1a3f5c2802f8fb.svg";
export { ForwardRef as ReactComponent };